import { render, staticRenderFns } from "./TemplateLayout.vue?vue&type=template&id=ae7b0c1a&scoped=true&"
import script from "./TemplateLayout.vue?vue&type=script&lang=ts&"
export * from "./TemplateLayout.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateLayout.vue?vue&type=style&index=0&id=ae7b0c1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@rakete/cli-plugin-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7b0c1a",
  null
  
)

export default component.exports